import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { loadFingerprintIfNeeded } from '../utils/fingerprint';
import './BottomNavigation.css';

export default function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { totalItems } = useCart();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname.startsWith('/product/');
    }
    return location.pathname === path;
  };

  return (
    <nav className="bottom-navigation">
      <button
        className={`nav-tab ${isActive('/') ? 'active' : ''}`}
        onClick={() => navigate('/')}
      >
        <span className="nav-icon">🛍️</span>
        <span className="nav-label">Store</span>
      </button>
      
      <button
        className={`nav-tab ${isActive('/cart') ? 'active' : ''}`}
        onClick={() => {
          void loadFingerprintIfNeeded('cart-click');
          navigate('/cart');
        }}
      >
        <span className="nav-icon" aria-hidden="true">
          🛒
          {totalItems > 0 && (
            <span className="nav-badge">{totalItems}</span>
          )}
        </span>
        <span className="nav-label">Cart</span>
      </button>
    </nav>
  );
}
